import React, { Component } from 'react'

class MessageList extends Component {

    render() {
        return (<div>MessageList</div>)
    }
}

export default MessageList


/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/ChatComponents/MessageList.js
 **/